import { render, staticRenderFns } from "./ProgressbarPage.vue?vue&type=template&id=d81fbba4&"
import script from "./ProgressbarPage.vue?vue&type=script&lang=js&"
export * from "./ProgressbarPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports